'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TemplateContainer = require('./TemplateContainer');

var _TemplateContainer2 = _interopRequireDefault(_TemplateContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MoveContainer = function (_React$Component) {
  (0, _inherits3.default)(MoveContainer, _React$Component);

  function MoveContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MoveContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MoveContainer.__proto__ || (0, _getPrototypeOf2.default)(MoveContainer)).call.apply(_ref, [this].concat(args))), _this), _this._dragHandle = function (el) {
      return _this.props.makeDragHandle(el, function () {
        return _this.props.y;
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MoveContainer, [{
    key: 'getTemplate',
    value: function getTemplate() {
      return this.refs.templateContainer.getTemplate();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.y !== nextProps.y || this.props.height !== nextProps.height || this.props.zIndex !== nextProps.zIndex;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var item = _props.item;
      var y = _props.y;
      var padding = _props.padding;
      var itemSelected = _props.itemSelected;
      var anySelected = _props.anySelected;
      var height = _props.height;
      var zIndex = _props.zIndex;
      var template = _props.template;


      return _react2.default.createElement(
        'div',
        {
          style: {
            position: y == null ? 'relative' : 'absolute',
            boxSizing: 'border-box',
            left: '0px',
            right: '0px',
            top: y == null ? '0px' : y + 'px',
            marginBottom: padding + 'px',
            height: y == null ? 'auto' : anySelected * (height.drag - height.natural) + height.natural + 'px',
            zIndex: zIndex
          }
        },
        _react2.default.createElement(_TemplateContainer2.default, {
          ref: 'templateContainer',
          item: item,
          template: template,
          itemSelected: itemSelected,
          anySelected: anySelected,
          dragHandle: this._dragHandle
        })
      );
    }
  }]);
  return MoveContainer;
}(_react2.default.Component);

MoveContainer.propTypes = {
  item: _react.PropTypes.object.isRequired,
  template: _react.PropTypes.func.isRequired,
  padding: _react.PropTypes.number.isRequired,
  y: _react.PropTypes.number,
  itemSelected: _react.PropTypes.number.isRequired,
  anySelected: _react.PropTypes.number.isRequired,
  height: _react.PropTypes.object.isRequired,
  zIndex: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired,
  makeDragHandle: _react.PropTypes.func.isRequired
};
exports.default = MoveContainer;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-draggable-list/js/MoveContainer.js
 ** module id = 369
 ** module chunks = 0
 **/